import PropTypes from 'prop-types';
import classNames from 'classnames';


// TODO: migrate to a loading icon from the material iconset
const IconLoading = ({ size = '' }) => {
  const classes = classNames(
    'loading-icon',
    size === 'small' ? 'loading-icon--small' : ''
  );

  return <i className={classes} />;
};

IconLoading.propTypes = {
  size: PropTypes.string
};

export default IconLoading;
